import { Flex, Box, Text } from '@mantine/core';
import { NavLink } from 'react-router';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import { useFlags } from 'src/feature-flags/FlagsHook';

type Props = {
  currentTab: string | undefined;
  basePath?: string;
};

type Tab = {
  value: string;
  label: string;
};

const BASE_TABS: Tab[] = [
  { value: 'summary', label: 'Summary' },
  { value: 'meeting-note', label: 'Meeting note' },
  { value: 'transcript', label: 'Transcript' },
  { value: 'pre-meeting', label: 'Pre-meeting' },
];

export const MeetingTabs = ({ currentTab, basePath = '/meetings' }: Props) => {
  const { flagEnabledComplianceChecking, flagEnabledMeetingActions } = useFlags();

  const tabs = [
    ...BASE_TABS,
    ...(flagEnabledMeetingActions ? [{ value: 'actions', label: 'Actions' }] : []),
    ...(flagEnabledComplianceChecking ? [{ value: 'compliance', label: 'Compliance' }] : []),
  ];
  return (
    <Flex gap="xxxs">
      {tabs.map(tab => {
        const isActive = currentTab === tab.value;
        return (
          <Box
            key={tab.value}
            component={NavLink}
            to={`${basePath}/${tab.value}`}
            bg={isActive ? 'brand.1' : 'white'}
            py="xxs"
            px="xs"
            style={{
              borderRadius: '6px',
              textDecoration: 'none',
              display: 'inline-block',
              transition: 'background-color 0.2s ease',
            }}
            onMouseEnter={(e: React.MouseEvent<HTMLAnchorElement>) => {
              if (isActive) {
                e.currentTarget.style.backgroundColor = 'var(--mantine-color-brand-1)';
              } else {
                e.currentTarget.style.backgroundColor = 'var(--mantine-color-gray-0)';
              }
            }}
            onMouseLeave={(e: React.MouseEvent<HTMLAnchorElement>) => {
              if (isActive) {
                e.currentTarget.style.backgroundColor = 'var(--mantine-color-brand-1)';
              } else {
                e.currentTarget.style.backgroundColor = 'white';
              }
            }}
          >
            <Text size="textSm" fw={FONT_WEIGHTS.semibold} c={isActive ? 'brand.8' : 'gray.6'}>
              {tab.label}
            </Text>
          </Box>
        );
      })}
    </Flex>
  );
};
